// extracted by mini-css-extract-plugin
export default {"last-seen":"_1Nf5byq4PO","lastSeen":"_1Nf5byq4PO"};
    if(module.hot) {
      // 1633091717167
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  